import React from 'react';

const LoadField = ({children}) => {
	return (
		<div>
			{children || <i className="fa fa-circle-o-notch fa-spin fa-lg fa-fw"></i>}
		</div>
	);

}

export default LoadField;


/** WEBPACK FOOTER **
 ** ./src/components/LoadField.js
 **/